import PropTypes from 'prop-types';
import Icon from "../../../Display/Icon/Icon";
import cn from "../../../../utils/cn";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DISPLAY_NAME = 'search-program-card';
function SupersetAddResourceButton(_ref) {
  let {
    disabled,
    isSelected,
    onClick
  } = _ref;
  return /*#__PURE__*/_jsxs("button", {
    type: "button",
    className: cn("".concat(DISPLAY_NAME, "__add-program-element ").concat(DISPLAY_NAME, "__add-program-button"), 'w-full flex items-center justify-center p-3 rounded', 'border border-solid border-dark-blue', isSelected ? 'bg-transparent text-dark-blue' : 'bg-dark-blue text-white'),
    onClick: onClick,
    disabled: disabled,
    "aria-label": isSelected ? 'Remove Resource' : 'Add Resource',
    children: [/*#__PURE__*/_jsx(Icon, {
      icon: isSelected ? 'IconMinusCircle' : 'IconPlusCircle',
      className: "".concat(DISPLAY_NAME, "__button-icon ").concat(DISPLAY_NAME, "__button-icon-").concat(isSelected ? 'remove' : 'add'),
      color: isSelected ? '#182A44' : '#FFFFFF'
    }), /*#__PURE__*/_jsx("div", {
      className: "pl-2",
      children: isSelected ? 'Remove Resource' : 'Add Resource'
    })]
  });
}
SupersetAddResourceButton.propTypes = {
  disabled: PropTypes.bool,
  isSelected: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};
SupersetAddResourceButton.defaultProps = {
  disabled: false,
  isSelected: false
};
export default SupersetAddResourceButton;
//# sourceMappingURL=SupersetAddResourceButton.js.map